import { useEffect, useState } from 'react'

export interface UsePlayerUserData {
  userVerified?: boolean,
  handleMessage?: (event: any) => void
}

export const defaultState: UsePlayerUserData = {
  userVerified: false,
  handleMessage: () => null
}

/**
 * Listens out for the player to verify the user
 */
const usePlayerUserData = () => {

  const [messageResult, setMessageResult] = useState(false)
  const [userVerified, setUserVerified] = useState(false)

  useEffect(() => {

    if (userVerified || typeof messageResult === 'undefined') return
    setUserVerified(messageResult)

  }, [messageResult, userVerified])

  const handleMessage = (event: any) => {

    const type = event?.detail?.type

    if (['login-success', 'registered-to-attend', 'ready'].includes(type)) {

      setMessageResult(true)

    }

  }

  return { userVerified, handleMessage }

}

export default usePlayerUserData
